export const Pagination_Types = {
    Pagination: "Pagination",
    LoadMore: "LoadMore",
}